<template>
  <v-container
    fluid
  >
    <v-row>
      <!-- <v-col cols="2" class="pb-0">
        <inventory-class-select-element
          v-model="inventoryClassId"
          :is-state="true"
          :is-railings="false"
          :is-glass="false"
          :is-vwd-glass="false"
          :is-panels="false"
          :is-sid="false"
          :is-rail-part="false"
          :is-paint="false"
          :is-equipment="false"
          :is-patio-door="false"
          :is-euro-door="false"
          :is-medical-aid="false"
        />
      </v-col> -->
      <v-col
        cols="2"
        class="pb-0"
      >
        <v-select
          v-model="filterStatus"
          label="Status"
          :items="statuses"
          item-text="name"
          item-value="id"
          hide-details="true"
          :loading="statusLoading"
          clearable
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            show-expand
            :single-expand="singleExpand"
            :expanded.sync="expandedItems"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            :loading="loading"
            dense
            fixed-header
            :height="windowHeight"
            :server-items-length="total"
            @update:options="updateOptions"
          >
            <template #[`item.data-table-expand`]="{ item }">
              <v-icon
                v-if="item.backorder_items && item.backorder_items.length > 0"
                style="font-size: 22px !important;"
                @click="toggleExpand(item)"
              >
                {{ expandedItems.includes(item) ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
              </v-icon>
            </template>
            <template #[`item.backorder_part_pick_list.code`]="{ item }">
              <text-highlight :queries="search">
                {{ item.backorder_part_pick_list ? item.backorder_part_pick_list.code : 'Backorder Pick List Not Submitted' }}
              </text-highlight>
            </template>
            <template #[`item.part_pick_list.project`]="{ item }">
              <text-highlight :queries="search">
                {{ item.part_pick_list && item.part_pick_list.project && item.part_pick_list.project.name ? item.part_pick_list.project.name : '-' }}
              </text-highlight>
            </template>
            <template #[`item.part_pick_list.job`]="{ item }">
              <span>
                <span style="font-weight: bold;"><text-highlight :queries="search">{{ item.part_pick_list && item.part_pick_list.job && item.part_pick_list.job.code ? `${item.part_pick_list.job.code}` : '' }}</text-highlight></span><text-highlight :queries="search"> - {{ item.part_pick_list && item.part_pick_list.job && item.part_pick_list.job.name ? item.part_pick_list.job.name : '' }}</text-highlight> <span style="color: #1976D2;"><text-highlight :queries="search">{{ item.part_pick_list && item.part_pick_list.job && item.part_pick_list.job.reference ? `; ${item.part_pick_list.job.reference}` : '' }}</text-highlight></span>
              </span>
            </template>
            <template #[`item.part_pick_list.code`]="{ item }">
              <text-highlight :queries="search">
                {{ item.part_pick_list && item.part_pick_list.code ? item.part_pick_list.code : '-' }}
              </text-highlight>
            </template>
            <template #[`item.backorder_part_pick_list.status`]="{ item }">
              <v-chip
                v-if="item.backorder_part_pick_list && item.backorder_part_pick_list.status"
                small
                :color="
                  item.backorder_part_pick_list.status.color
                    ? item.backorder_part_pick_list.status.color
                    : 'grey'
                "
                text-color="white"
              >
                <text-highlight :queries="search">
                  {{
                    item.backorder_part_pick_list.status.name
                      ? item.backorder_part_pick_list.status.name
                      : ''
                  }}
                </text-highlight>
              </v-chip>
              <span v-else>-</span>
            </template>
            <template #[`item.total_quantity`]="{ item }">
              <text-highlight :queries="search">
                {{ item.total_quantity ? item.total_quantity : '-' }}
              </text-highlight>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                v-if="!item.backorder_part_pick_list"
                class="ml-1 mt-1 mb-1"
                color="warning"
                outlined
                small
                @click="requestToSupply(item)"
              >
                REQUEST TO SUPPLY
              </v-btn>
            </template>
            <template #expanded-item="{ headers, item }">
              <td
                :colspan="headers.length"
                class="pl-0 pr-0"
                style="padding-right: 0px !important; padding-left: 0px !important;"
              >
                <v-container
                  fluid
                  :style="`background-color: ${item.index % 2 === 0 ? isDarkMode ? '#1e1e1e' : 'white' : isDarkMode ? '#556b2f' : '#E8F5E9'} !important;`"
                >
                  <v-row
                    v-for="backorderItem, index in item.backorder_items"
                    :key="backorderItem.id"
                    align="center"
                    justify="center"
                    :style="`border-bottom: ${index === item.backorder_items.length - 1 ? 'none' : '1px solid #c1c1c1'};`"
                  >
                    <v-col
                      class="pt-2 pb-2 pr-1"
                      cols="2"
                    >
                      <span style="font-size: 14px;">QR Code: </span><span style="font-weight: bold; font-size: 14px;"><text-highlight :queries="search">{{ backorderItem.part_pick_list_item && backorderItem.part_pick_list_item.inventory_tag ? backorderItem.part_pick_list_item.inventory_tag : '-' }}</text-highlight></span>
                    </v-col>
                    <v-col
                      class="pt-2 pb-2 pr-1 pl-0"
                      cols="4"
                    >
                      <span style="font-size: 14px;">Item Name: </span><span style="font-weight: bold; font-size: 14px;"><text-highlight :queries="search">{{ backorderItem.part_pick_list_item && backorderItem.part_pick_list_item.inventory_tag_item && backorderItem.part_pick_list_item.inventory_tag_item.item && backorderItem.part_pick_list_item.inventory_tag_item.item.name && backorderItem.part_pick_list_item.inventory_tag_item.item.material_id ?
                        `${backorderItem.part_pick_list_item.inventory_tag_item.item.material_id}: ${backorderItem.part_pick_list_item.inventory_tag_item.item.name}` : '-' }}</text-highlight></span>
                    </v-col>
                    <v-col
                      class="pt-2 pb-2 pr-1 pl-0"
                      cols="2"
                    >
                      <span style="font-size: 14px;">UOM: </span><span style="font-weight: bold; font-size: 14px;"><text-highlight :queries="search">{{ backorderItem.part_pick_list_item && backorderItem.part_pick_list_item.inventory_tag_item && backorderItem.part_pick_list_item.inventory_tag_item.uom && backorderItem.part_pick_list_item.inventory_tag_item.uom.name ? backorderItem.part_pick_list_item.inventory_tag_item.uom.name : '-' }}</text-highlight></span>
                    </v-col>
                    <v-col
                      class="pt-2 pb-2 pr-1 pl-0"
                      cols="2"
                    >
                      <span style="font-size: 14px;">Quantity Required: </span><span style="font-weight: bold; font-size: 14px;"><text-highlight :queries="search">{{ backorderItem.quantity_required ? backorderItem.quantity_required : '-' }}</text-highlight></span>
                    </v-col>
                    <v-spacer />
                  </v-row>
                </v-container>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    items: [],
    headers: [
      { text: '', value: 'data-table-expand', width: '2%' },
      { text: 'ID', value: 'id', width: '3%' },
      { text: 'Backorder PL#', value: 'backorder_part_pick_list.code', width: '10%' },
      { text: 'Project', value: 'part_pick_list.project', width: '8%' },
      { text: 'Work Order', value: 'part_pick_list.job', width: '10%' },
      { text: 'Original PL#', value: 'part_pick_list.code', width: '8%' },
      { text: 'Total Quantity', value: 'total_quantity', width: '5%' },
      {
        text: 'Status', value: 'backorder_part_pick_list.status', width: '10%', align: 'center',
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'end',
        width: '20%',
        sortable: false,
      },
    ],
    pagination: {
      itemsPerPage: 100,
      page: 1,
    },
    sort: {
      order_by_first: 'id',
      direction_sort: true,
    },
    footer: {
      'items-per-page-options': [100, 500, 1000, -1],
    },
    total: 0,
    topSpaceHeight: 230,
    windowHeight: 1000,
    expandedItems: [],
    singleExpand: false,
    loading: false,
    statusLoading: false,

    statuses: [],

    filterStatus: null,
    inventoryClassId: null,
  }),

  computed: {
    ...mapState({
      search: (state) => state.search,
      isDarkMode: 'isDarkMode',
    }),
  },
  watch: {
    search() {
      this.get();
    },
    pagination() {
      this.get();
    },
    inventoryClassId() {
      this.get();
    },
    filterStatus() {
      this.get();
    },
  },

  created() {
    this.init();
    window.scrollTo(0, document.body.scrollHeight);
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    init() {
      this.get();
      this.getStatuses();
    },
    async get() {
      this.loading = true;
      const submitModel = {
        filters: {
          status_id: this.filterStatus,
        },
        search: this.search,
        pagination: this.pagination,
        sort: this.sort,
      };
      const res = await this.$api.backorder.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data) {
        this.items = [];
        this.loading = false;
        return;
      }
      this.items = res.data;
      this.total = res.total;
      this.loading = false;
    },

    async getStatuses() {
      this.statusLoading = true;
      this.statuses = await this.$api.partPickListStatus.get();
      this.statusLoading = false;
    },

    async requestToSupply(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to create a new pick list for this backorder?',
      });
      if (!confirm) return;
      this.$bus.$emit('loading');
      const res = await this.$api.backorder.get(`request-to-supply/${item.id}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async softDelete(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this item?',
      });
      if (!confirm) return;
      const res = await this.$api.backorder.delete(item.id);

      if (res === '1001') {
        this.$bus.$emit(
          'showError',
          `Job ${item.name} is already in production`,
        );
        return;
      }

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }

      this.$bus.$emit('showSuccess');
      this.get();
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
    },

    updateOptions(newOptions) {
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      };
    },

    toggleExpand(item) {
      if (!item) return;
      const index = this.expandedItems.indexOf(item);
      if (index > -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandedItems.push(item);
      }
    },
  },
};
</script>
